/**
 * 통신사 코드. KCB 가 정한 값이다.
 *
 * 예전에는 `"x"`(모름)를 보냈다. KCB 는 받아 주지만, 통신사를 알면 인증 성공률이
 * 올라가고 실패했을 때 원인도 가려진다. 무엇보다 **화면에 선택칸이 있는데 서버로는
 * 안 가는** 상태를 만들지 않는다.
 *
 * 알뜰폰은 **어느 망을 쓰는지** 고른다. 사용자는 대개 그걸 모르므로 라벨에 적어
 * 둔다 — 「알뜰폰(SKT망)」 처럼.
 */
export const TELECOM_OPTIONS = [
  { value: "01", label: "SKT" },
  { value: "02", label: "KT" },
  { value: "03", label: "LG U+" },
  { value: "04", label: "알뜰폰 (SKT망)" },
  { value: "05", label: "알뜰폰 (KT망)" },
  { value: "06", label: "알뜰폰 (LG U+망)" },
] as const;
